import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe usarse dentro de AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  // Estado: null = verificando, false = no autenticado, objeto = autenticado
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Verificar si hay una sesión activa al cargar
  const checkAuth = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/auth/me`, {
        withCredentials: true // Envía cookies HTTP-only
      });
      setUser(response.data);
    } catch (error) {
      // Sin sesión válida o token expirado
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (username, password) => {
    const response = await axios.post(`${API_URL}/auth/login`, {
      username,
      password
    }, {
      withCredentials: true // Recibe y almacena la cookie HTTP-only
    });
    
    const { user: userData } = response.data;
    setUser(userData);
    return userData;
  };

  const logout = useCallback(async () => {
    try {
      await axios.post(`${API_URL}/auth/logout`, {}, {
        withCredentials: true // Envía cookie para invalidarla
      });
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    } finally {
      setUser(null);
    }
  }, []);

  const isAdmin = user?.role === 'admin';
  const isLocal = user?.role === 'local';
  const isBodega = user?.role === 'bodega';
  const warehouseId = user?.warehouse_id;

  return (
    <AuthContext.Provider value={{ 
      user, 
      login, 
      logout, 
      loading, 
      isAdmin, 
      isLocal, 
      isBodega, 
      warehouseId,
      isAuthenticated: !!user 
    }}>
      {children}
    </AuthContext.Provider>
  );
};